import { useState } from 'react';
import { Dialog } from '@headlessui/react';
import VgaPartnerCertificate from './layout/VgaPartnerCertificate';
import SkillReportData from './SkillReportData';

const NewReportView = ({ batchData, isAllTaskDone }: any) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState<string | null>(null);
  return (
    <div>
      <>
        <div className='space-y-4'>
          <button
            onClick={() => {
              setIsOpen(true);
            }}
            className='bg-primary px-4 py-2 cursor-pointer text-white font-semibold rounded-lg'>
            Get Certificate
          </button>
        </div>

        <Dialog
          open={isOpen}
          onClose={() => setIsOpen(false)}
          className='relative z-50'>
          <div
            className='fixed inset-0 bg-black/40 backdrop-blur-sm'
            aria-hidden='true'
          />
          <div className='fixed inset-0 overflow-y-auto'>
            <div className='flex min-h-full items-center justify-center p-4'>
              {selectedOption === null ? (
                <Dialog.Panel className='mx-auto max-w-5xl rounded-2xl bg-gradient-to-br from-white to-gray-100 p-10 shadow-2xl sm:min-w-[900px]'>
                  <Dialog.Title className='text-4xl font-bold text-center text-pink-600'>
                    Congratulations!
                  </Dialog.Title>

                  <div className='grid md:grid-cols-2 gap-10 mt-8'>
                    <div className='flex flex-col items-center bg-white rounded-xl p-6 shadow-md hover:shadow-lg transition-shadow duration-300'>
                      <span className='text-5xl mb-4'>🏅</span>
                      <h3 className='text-xl font-semibold mb-3 text-gray-800'>
                        Certificate
                      </h3>
                      <button
                        onClick={() => setSelectedOption('certificate')}
                        className='bg-indigo-600 text-white px-6 py-2 rounded-lg shadow hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-opacity-50 transition duration-300'>
                        View Certificate
                      </button>
                    </div>

                    <div className='flex flex-col items-center bg-white rounded-xl p-6 shadow-md hover:shadow-lg transition-shadow duration-300'>
                      <span className='text-5xl mb-4'>📄</span>
                      <h3 className='text-xl font-semibold mb-3 text-gray-800'>
                        Performance Snaoshot
                      </h3>
                      <button
                        onClick={() => setSelectedOption('report')}
                        className='bg-indigo-600 text-white px-6 py-2 rounded-lg shadow hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-opacity-50 transition duration-300'>
                        View Report
                      </button>
                    </div>
                  </div>

                  <div className='mt-10'>
                    <p className='text-center text-xl font-semibold text-gray-700 mb-6'>
                      Well done! Your journey has been completed successfully.{' '}
                      <br />
                      Here's what's Next:{' '}
                    </p>

                    <div className='grid grid-cols-1 md:grid-cols-1 gap-6 text-sm'>
                      <div className='bg-white rounded-lg p-5 shadow'>
                        <h4 className='text-center text-indigo-700 font-semibold text-lg mb-3'>
                          Craft Your Presence
                        </h4>
                        <p className='text-gray-600 text-center text-xs mb-4'>
                          This Section helps you translate your experience into
                          a compelling narrative across platforms.
                        </p>
                        <ul className='space-y-2 text-center text-gray-800'>
                          <li>
                            <a
                              href='https://drive.google.com/file/d/1adqAw-X92do3gHJkcVItFnCWANgRutQI/view?usp=sharing'
                              target='_blank'
                              rel='noopener noreferrer'
                              className='hover:text-indigo-600 hover:underline'>
                              🔗 Stand out on LinkedIn
                            </a>
                          </li>
                          <li>
                            <a
                              href='https://drive.google.com/file/d/1ZT5zFhWdtjb5xWG9hnTBY0jJCwxevX1E/view?usp=sharing'
                              target='_blank'
                              rel='noopener noreferrer'
                              className='hover:text-indigo-600 hover:underline'>
                              📄 Add to CV
                            </a>
                          </li>
                          <li>
                            <a
                              href='https://drive.google.com/file/d/1vWZDBNV-5meW3GOzTW0ZZwf29BoGwSOV/view?usp=sharing'
                              target='_blank'
                              rel='noopener noreferrer'
                              className='hover:text-indigo-600 hover:underline'>
                              🎤 Include in Interviews
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>

                  <div className='text-center mt-8'>
                    <button
                      onClick={() => setIsOpen(false)}
                      className='px-8 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 transition duration-300'>
                      Close
                    </button>
                  </div>
                </Dialog.Panel>
              ) : (
                // <div></div>
                <Dialog.Panel className='mx-auto max-w-3xl rounded-xl bg-white shadow-xl'>
                  {selectedOption === 'certificate' ? (
                    <div className='-mx-48 bg-white'>
                      {' '}
                      <VgaPartnerCertificate
                        batchData={batchData}
                        isAllTaskDone={isAllTaskDone}
                      />
                    </div>
                  ) : (
                    <div>
                      <SkillReportData batchData={batchData} />
                    </div>
                  )}
                  <div className='p-4 border-t text-right'>
                    <button
                      onClick={() => setSelectedOption(null)}
                      className='text-blue-600 hover:underline'>
                      ← Back to options
                    </button>
                  </div>
                </Dialog.Panel>
              )}
            </div>
          </div>
        </Dialog>
      </>
    </div>
  );
};

export default NewReportView;
